import { Box } from "@mantine/core";

import { colors } from "#app/theme/v2/colors";
import { radius } from "#app/theme/v2/radius";
import { spacing } from "#app/theme/v2/spacing";

import { Text } from "../Typographies/Text";

type BadgeVariant = "success" | "error" | "warning" | "info" | "neutral" | "alternative";
type BadgeProps = {
  children: React.ReactNode;
  variant?: BadgeVariant;
  shape?: "rounded" | "squared";
};

const BADGE_VARIANTS: Record<BadgeVariant, { bg: string; textColor: string }> = {
  success: {
    bg: colors.bg.status.success.secondary,
    textColor: colors.text.success,
  },
  error: {
    bg: colors.bg.status.error.secondary,
    textColor: colors.text.errorDefault,
  },
  warning: {
    bg: colors.bg.status.warning.secondary,
    textColor: colors.text.warning,
  },
  info: {
    bg: colors.bg.status.info.secondary,
    textColor: colors.text.info,
  },
  neutral: {
    bg: colors.bg.elevation.quaternary,
    textColor: colors.text.secondaryDefault,
  },
  alternative: {
    bg: colors.bg.status.alternative.tertiary,
    textColor: colors.text.alternative,
  },
};

const Badge = ({ children, variant = "success", shape = "rounded" }: BadgeProps) => {
  const { bg, textColor } = BADGE_VARIANTS[variant];
  return (
    <Box
      bg={bg}
      px={spacing[2.5]}
      py={spacing[1]}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        borderRadius: shape === "rounded" ? radius.md : radius.xxs,
        whiteSpace: "nowrap",
      }}
    >
      <Text
        size="tiny"
        type={shape === "rounded" ? "medium" : "regular"}
        color={textColor}
        textAlign="center"
      >
        {children}
      </Text>
    </Box>
  );
};

export { Badge };
